import { render, staticRenderFns } from "./deletePaymentPool.vue?vue&type=template&id=c56c7da8&scoped=true"
import script from "./deletePaymentPool.vue?vue&type=script&lang=js"
export * from "./deletePaymentPool.vue?vue&type=script&lang=js"
import style0 from "./deletePaymentPool.vue?vue&type=style&index=0&id=c56c7da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56c7da8",
  null
  
)

export default component.exports